import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';

type Ctx = { open: boolean; setOpen: (v: boolean) => void; toggle: () => void };
const SidebarCtx = createContext<Ctx | null>(null);

export function SidebarProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);

  // Close drawer on viewport resize into desktop (>= md)
  useEffect(() => {
    const mql = window.matchMedia('(min-width: 768px)');
    const onChange = (e: MediaQueryListEvent | MediaQueryList) => {
      if (e.matches) setOpen(false);
    };
    onChange(mql);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  // Lock body scroll while drawer open
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prev; };
  }, [open]);

  return (
    <SidebarCtx.Provider value={{ open, setOpen, toggle: () => setOpen(!open) }}>
      {children}
    </SidebarCtx.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components -- Provider 와 훅 공존이 컨텍스트 이디엄
export function useSidebar() {
  const v = useContext(SidebarCtx);
  if (!v) throw new Error('useSidebar must be used inside SidebarProvider');
  return v;
}
